import React, { Component, useEffect, useMemo } from "react";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { updateEditValue } from "../../store/slices/waitlist";
import { useDispatch, useSelector } from "react-redux";
import { Navbar } from "./navBar";
import { useQuery, getPartySizeOptions } from "../../utils";
import { useGlobalState } from "../../hooks/useGlobalState";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "#4a4f54",
  },
  title: {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: 500,
  },
  options: {
    height: "calc(100vh - 170px)",
    overflowY: "auto",
    width: "100%",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  option: {
    margin: "60px auto",
    width: 236,
    height: 74,
    padding: "24px 110px 24px",
    borderRadius: "37px",
    border: "solid 2px #fc3",
    fontSize: "28px",
    textAlign: "center",
    lineHeight: "20px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  enabled: {
    border: "solid 2px #fc3",
    cursor: "pointer",
  },
  disabled: {
    border: "solid 2px #d9d8d8",
    cursor: "pointer",
    color: "#d9d8d8",
  },
});

export default ({}) => {
  const [language] = useGlobalState("language");
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mode } = useQuery();
  const { search } = useLocation();
  const tables = useSelector((state) => state.merchant.tables);
  const disabled = useSelector((state) => state.waitlist.disabled);
  const partySizeOptions = getPartySizeOptions(tables);
  const nextPage = window.location.pathname.replace(/\/[^\/]*$/, "/contact");
  const backPage = window.location.pathname.replace(/\/[^\/]*$/, "/start");
  const startPage = window.location.pathname.replace(/\/[^\/]*$/, "/start");
  const onChoosePartySize = (size) => {
    dispatch(updateEditValue({ partySize: size }));
    navigate(nextPage + search);
  };
  useEffect(() => {
    return () => {
      console.log("cleanup in partySize");
    };
  }, []);

  const isShowCn = useMemo(() => {
    return language.includes("zh");
  }, [language]);

  return (
    <div className={classes.root}>
      <Navbar
        backUrl={backPage}
        closeUrl={startPage}
        invisible={mode === "kiosk"}
      />
      <div className={classes.title}>
        <span>How many people in your party </span>
        {isShowCn && <span>(人数)</span>}
        <span>?</span>
      </div>
      <div className={classes.options}>
        {partySizeOptions.map((option) => (
          <div
            className={`${classes.option} ${
              disabled ? classes.disabled : classes.enabled
            }`}
            onClick={() => onChoosePartySize(option)}
            key={option}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};
